import ApiError from "../../errors/ApiError";
import { ROOM_NOT_FOUND_ERROR } from "../../rooms/errors";

export class RoomNotFoundError extends ApiError {
  constructor() {
    super(ROOM_NOT_FOUND_ERROR);
  }
}
